/**
 * What: Shopify per-store build honest progress copy, one row per kind of store data.
 * Transport / data-flow: Pure string dictionary segment merged by shopify-component-copy.ts for Shopify UI consumers.
 *
 */
export const shopifyComponentStoreIntelligenceBuildProgressCopy = {
    storeIntelligenceStoreBuildProgress: {
        rowSettings: 'Store settings',
        rowProducts: 'Products',
        rowCustomers: 'Customers',
        rowOrders: 'Orders',
        rowInventory: 'Inventory',
        rowLocations: 'Locations',
        rowDiscounts: 'Discounts',
        rowPriceRules: 'Price rules',
        rowContent: 'Pages',
        rowThemes: 'Themes',
        rowFulfillments: 'Fulfillments',
        stateQueued: 'Queued',
        stateExporting: 'Exporting',
        stateDownloading: 'Downloading',
        stateLoading: 'Loading',
        stateCompleted: 'Completed',
        stateFailed: "Couldn't load",
        stateNoAccess: 'No access',
        // Shown when this kind is still refreshing but an earlier copy can already be used.
        stateUsable: 'Ready to use',
        recordCount: (count) => `${count.toLocaleString()} ${count === 1 ? 'record' : 'records'}`,
        // Five-word rotating captions shown while a component is still in progress (not yet
        // completed), so a long-running stage keeps giving honest, changing feedback instead of a
        // static label. Rotation logic lives in useRotatingProgressPhrase; this is copy only.
        progressPhrasesSettings: [
            "Reading your store's currency now",
            "Checking your shop's basic settings",
            "Confirming your store's home currency",
            'Looking up your shop details',
        ],
        progressPhrasesProducts: [
            'Counting every product you sell',
            'Scanning your full product catalog',
            'Reading titles, prices and images',
            'Building your product intelligence now',
        ],
        progressPhrasesCustomers: [
            'Counting your total customer base',
            'Reading customer purchase history now',
            'Building your customer audience profile',
            'Scanning your full customer list',
        ],
        progressPhrasesOther: [
            'Reading this store data now',
            'Copying these details from Shopify',
            'Checking every record Shopify sends',
            'Saving these details for you',
        ],
        progressPhrasesOrders: [
            "Counting every order you've had",
            'Reading your recent order history',
            "Calculating your store's sales patterns",
            'Scanning sixty days of orders',
        ],
    },
};
//# sourceMappingURL=store-intelligence-build-progress.js.map